import routes from "../Routes/routes";

export const permissionRoutesObj = {
    WEB_COMPANY_MENU: [],
    WEB_COMPANY_READ: [routes.company.main, routes.company.update],
    WEB_COMPANY_UPDATE: [],
    WEB_PROFILE_READ: [], // Validation in view
    WEB_PROFILE_UPDATE: [], // Validation in view
    WEB_EMPLOYEE_MENU: [], // Does not apply
    WEB_EMPLOYEE_READ: [routes.employee.list],
    WEB_EMPLOYEE_CREATE: [], // Validation in view
    WEB_EMPLOYEE_DELETE: [], // Does not apply
    WEB_EMPLOYEE_UPDATE: [], // Validation in view
    WEB_EMPLOYEE_EXPORT: [], // Does not apply
    WEB_VCARD_SETTINGS_UPDATE: [],//Validation in view
    WEB_HEADERS_UPDATE: [],//Validation in view
    WEB_USER_RESTRICTION_UPDATE: [],//Validation in view
    WEB_EMPLOYEE_DOCUMENT_MENU: [], // Does not apply
    WEB_EMPLOYEE_DOCUMENT_READ: [], // Validation in view
    WEB_EMPLOYEE_DOCUMENT_CREATE: [],
    WEB_EMPLOYEE_DOCUMENT_UPDATE: [],
    WEB_EMPLOYEE_DOCUMENT_DELETE: [],
    WEB_SUPPLIER_DOCUMENT_MENU: [],// Does not apply
    WEB_SUPPLIER_DOCUMENT_READ: [], // Validation in view
    WEB_SUPPLIER_DOCUMENT_CREATE: [],
    WEB_SUPPLIER_DOCUMENT_UPDATE: [],
    WEB_SUPPLIER_DOCUMENT_DELETE: [],
    WEB_CONTRACTOR_DOCUMENT_MENU: [],// Does not apply
    WEB_SUPPLIER_VEHICLE_DOCUMENT_MENU: [],// Does not apply
    WEB_SUPPLIER_VEHICLE_DOCUMENT_READ: [], // Validation in view
    WEB_SUPPLIER_VEHICLE_DOCUMENT_CREATE: [],
    WEB_SUPPLIER_VEHICLE_DOCUMENT_UPDATE: [],
    WEB_SUPPLIER_VEHICLE_DOCUMENT_DELETE: [],
    WEB_CONTRACTOR_VEHICLE_DOCUMENT_MENU: [],// Does not apply
    WEB_CONTRACTOR_VEHICLE_DOCUMENT_CREATE: [],
    WEB_CONTRACTOR_VEHICLE_DOCUMENT_UPDATE: [],
    WEB_CONTRACTOR_VEHICLE_DOCUMENT_DELETE: [],
    WEB_WORK_SHIFT_MENU: [],
    WEB_WORK_SHIFT_READ: [routes.workshift.list],
    WEB_WORK_SHIFT_CREATE: [],
    WEB_WORK_SHIFT_UPDATE: [],
    WEB_WORK_SHIFT_DELETE: [],
    WEB_WORK_SHIFT_MANAGE_USERS: [],
    WEB_PRIVILEGE_MENU: [],
    WEB_PRIVILEGE_READ: [routes.roles.list],
    WEB_PRIVILEGE_CREATE: [],
    WEB_PRIVILEGE_UPDATE: [],
    WEB_PRIVILEGE_DELETE: [],
    WEB_PRIVILEGE_MANAGE_USERS: [],
    WEB_VEHICLE_MENU: [],
    WEB_VEHICLE_READ: [routes.vehicleFleet.list],
    WEB_VEHICLE_CREATE: [],
    WEB_VEHICLE_UPDATE: [],
    WEB_VEHICLE_DELETE: [],
    WEB_ZONE_MENU: [],
    WEB_ZONE_READ: [routes.zone.list, routes.zone.details], // dode
    WEB_ZONE_CREATE: [],
    WEB_ZONE_UPDATE: [routes.zone.details],
    WEB_ZONE_DELETE: [],
    WEB_ZONE_MANAGE_USERS: [],

    WEB_DEVICE_MENU: [],
    WEB_DEVICE_READ: [routes.devices.list],
    WEB_DEVICE_CREATE: [routes.devices.create],
    WEB_DEVICE_UPDATE: [routes.devices.update],
    WEB_DEVICE_DELETE: [],
    WEB_DEVICE_EXPORT: [],
    WEB_DEVICE_RESTRICTION_UPDATE:[routes.devices.configuration],

    WEB_ZONE_READ_DEVICES: [routes.zone.devices],
    WEB_ZONE_CREATE_DEVICES: [routes.zone.devicesCreate], // ADD NEW PLANE
    WEB_ZONE_UPDATE_DEVICES: [routes.zone.devicesUpdate], // UPDATE /ADD/REMOVE LOCATION(PIN)
    WEB_ZONE_DELETE_DEVICES: [],
    WEB_ZONE_OPEN_THE_DOOR_DEVICE: [],

    WEB_REPORTS_MENU:[],
    WEB_REPORTS_READ: [],
    WEB_REPORTS_EXPORT: [],
    WEB_BACK_UP_MENU: [],
    WEB_BACK_UP_READ: [routes.backup.list],
    WEB_BACK_UP_CREATE: [],
    WEB_BACK_UP_FULL_RESTORE: [],
    WEB_BACK_UP_PARTIAL_RESTORE: [],
    WEB_PAYROLL_MENU: [],
    WEB_PAYROLL_CREATE: [],
    WEB_PAYROLL_UPDATE: [],
    WEB_PAYROLL_READ: [],
    WEB_ONBOARDING_MENU: [],
    WEB_ONBOARDING_CREATE: [],
    WEB_ONBOARDING_UPDATE: [],
    WEB_ONBOARDING_READ: [routes.onboarding.list],
    WEB_ONBOARDING_DELETE: [],
    WEB_HOSPITALITY_MENU: [],
    WEB_HOSPITALITY_CREATE: [],
    WEB_HOSPITALITY_UPDATE: [],
    WEB_HOSPITALITY_READ: [],
    WEB_HOSPITALITY_DELETE: [],
    WEB_EMAIL_SETTINGS_MENU: [],
    WEB_EMAIL_SETTINGS_CREATE: [],
    WEB_EMAIL_SETTINGS_UPDATE: [],
    WEB_EMAIL_SETTINGS_READ: [routes.email.list],
    WEB_NOTIFICATION_MENU: [],

    WEB_LOG_MENU: [],
    WEB_LOG_READ: [],
    WEB_LOG_EXPORT: [],

    WEB_ACCESS_HISTORY_MENU: [],
    WEB_ACCESS_USER_READ: [],
    WEB_ACCESS_USER_EXPORT: [],
    WEB_ACCESS_VEHICLE_READ: [],
    WEB_ACCESS_VEHICLE_EXPORT: [],

    WEB_SUPPLIER_MENU: [],
    WEB_SUPPLIER_CREATE: [],
    WEB_SUPPLIER_UPDATE: [],
    WEB_SUPPLIER_DELETE: [],
    WEB_SUPPLIER_READ: [],
    WEB_SUPPLIER_FORM: [],
    WEB_SUPPLIER_ORDER_READ: [],
    WEB_SUPPLIER_ORDER_UPDATE: [],
    WEB_SUPPLIER_ORDER_DELETE: [],
    WEB_SUPPLIER_ORDER_CREATE: [],
    WEB_SUPPLIER_RESTRICTION_UPDATE: [routes.suppliers.restriction],

    WEB_SUPPLIER_DOCUMENT_VEHICLE_RESTRICTION_UPDATE: [],
    WEB_CONTRACTOR_MENU: [],
    WEB_CONTRACTOR_CREATE: [],
    WEB_CONTRACTOR_UPDATE: [],
    WEB_CONTRACTOR_DELETE: [],
    WEB_CONTRACTOR_READ: [],
    WEB_CONTRACTOR_FORM: [],
    WEB_CONTRACTOR_CONTRACT_READ: [],
    WEB_CONTRACTOR_CONTRACT_UPDATE: [],
    WEB_CONTRACTOR_CONTRACT_DELETE: [],
    WEB_CONTRACTOR_CONTRACT_CREATE: [],
    WEB_CONTRACTOR_RESTRICTION_UPDATE: [],
    WEB_CONTRACTOR_DOCUMENT_RESTRICTION_UPDATE: [],
    WEB_CONTRACTOR_DOCUMENT_VEHICLE_RESTRICTION_UPDATE: [],
    WEB_CONTRACTOR_MANAGE_DOCUMENTS:[],
    WEB_EVENT_READ: [routes.event.create],
    WEB_EVENT_CREATE: [routes.event.create],
    WEB_EVENT_UPDATE: [],
    WEB_EVENT_DELETE: [],
    WEB_ATTENDANCE_MENU: [],
    WEB_ATTENDANCE_READ: [],
    WEB_ATTENDANCE_CREATE: [],
    WEB_ATTENDANCE_UPDATE: [],
    WEB_ATTENDANCE_DELETE: [],

    WEB_DEPARTMENT_MENU: [],

    WEB_DEPARTMENT_READ: [routes.department.list],
    WEB_DEPARTMENT_CREATE: [],
    WEB_DEPARTMENT_UPDATE: [],
    WEB_DEPARTMENT_DELETE: [],

    WEB_HOLIDAY_READ: [],
    WEB_HOLIDAY_CREATE: [],
    WEB_HOLIDAY_UPDATE: [],
    WEB_HOLIDAY_DELETE: [],
    WEB_HOME_OFFICE_READ: [],

    WEB_CARD_READ: [routes.cards.list],
    WEB_CARD_CREATE: [], // Does not apply
    WEB_CARD_DELETE: [], // Does not apply
    WEB_CARD_EXPORT: [], // Does not apply
    WEB_CARD_MANAGE_TEMPLATES:[], // Does not apply
    WEB_CARD_MANAGE_USERS:[],
    WEB_CARD_DESIGNER_MENU: [],
    WEB_CARD_DESIGNER_READ: [],
    WEB_CARD_DESIGNER_CREATE: [],
    WEB_CARD_DESIGNER_UPDATE: [],
    WEB_CARD_DESIGNER_DELETE: [],
    WEB_ANNOUNCEMENT_READ: [routes.announcement.list],
    WEB_ANNOUNCEMENT_CREATE: [routes.announcement.create],
    WEB_ANNOUNCEMENT_DELETE: [], // Does not apply
    WEB_ANNOUNCEMENT_EXPORT: [], // Does not apply
    WEB_GUARD_READ: [routes.guard.list],
    WEB_LOG_PLATFORM_READ: [],
    WEB_LOG_PLATFORM_EXPORT: [],
    WEB_LOG_ACTION_READ: [],
    WEB_LOG_ACTION_EXPORT: [],
    WEB_RESOURCES_READ: [],
    WEB_RESOURCES_CREATE: [],
    WEB_RESOURCES_UPDATE: [],
    WEB_RESOURCES_DELETE: [],
    WEB_HID_MENU: [],
    WEB_HID_READ: [],
    WEB_HID_CREATE: [],
    WEB_HID_UPDATE: [],
    WEB_HID_DELETE: [],
    WEB_HARD_DELETE_DELETE: [],
    WEB_HARD_DELETE_RECOVER: [],
    WEB_HARD_DELETE_READ: [],
    WEB_HARD_DELETE_MENU: [],
    WEB_CHART_DELETE: [],
    WEB_CHART_UPDATE: [],
    WEB_CHART_CREATE: [],
    WEB_CHART_READ: [routes.graphs.list],
    WEB_CHART_MENU: [],
    WEB_SYSTEM_CONFIG_READ:[routes.systemConfig.main],
    WEB_SYSTEM_CONFIG_CREATE:[], // Does not apply
    WEB_SYSTEM_CONFIG_UPDATE:[], // Does not apply
    WEB_SYSTEM_CONFIG_DELETE:[], // Does not apply

    WEB_APPROVAL_FLOW_READ: [routes.approval.list, routes.approval.create, routes.approval.update, routes.approvalTracker.main],
    WEB_APPROVAL_FLOW_CREATE: [routes.approval.create],
    WEB_APPROVAL_FLOW_UPDATE: [routes.approval.update],
    WEB_APPROVAL_FLOW_DELETE: [], // Does not apply

    WEB_DISTRIBUTION_CENTER_READ:[routes.distributionCenter.list],
    WEB_DISTRIBUTION_CENTER_CREATE:[],// Does not apply
    WEB_DISTRIBUTION_CENTER_UPDATE:[],// Does not apply
    WEB_DISTRIBUTION_CENTER_DELETE:[],// Does not apply

    WEB_SERVICE_TYPE_READ:[routes.serviceType.list],
    WEB_SERVICE_TYPE_CREATE:[],// Does not apply
    WEB_SERVICE_TYPE_UPDATE:[],// Does not apply
    WEB_SERVICE_TYPE_DELETE:[],// Does not apply

    WEB_LOGISTIC_REQUEST_READ: [routes.transportRequest.list],
    WEB_LOGISTIC_REQUEST_CREATE: [routes.transportRequest.create],
    WEB_LOGISTIC_REQUEST_UPDATE: [],// Does not apply
    WEB_LOGISTIC_REQUEST_DELETE: [],// Does not apply

    WEB_INGREDIENT_READ:[routes.foodieIngredient.addEdit],

    WEB_FOODIE_ITEM_READ:[routes.foodieDish.create, routes.foodieDish.update],
    WEB_FOODIE_ITEM_CREATE:[routes.foodieDish.create],
    WEB_FOODIE_ITEM_UPDATE:[],

    WEB_FOODIE_CAFETERIA_READ: [routes.foodieCafeteria.create, routes.foodieCafeteria.update],
    WEB_FOODIE_CAFETERIA_CREATE: [routes.foodieCafeteria.create],
    WEB_FOODIE_CAFETERIA_UPDATE: [routes.foodieCafeteria.update],
    WEB_FOODIE_MEAL_TIME_READ:[],// Does not apply
    WEB_FOODIE_MEAL_TIME_CREATE:[],// Does not apply


    WEB_VISITOR_TYPE_READ: [routes.visitorType.create, routes.visitorType.update],
    WEB_VISITOR_TYPE_CREATE: [routes.visitorType.create],
    WEB_VISITOR_TYPE_UPDATE: [routes.visitorType.update],

    WEB_VISITOR_INVITATION_READ:[routes.visitorInvitation.details],
    WEB_VISITOR_INVITATION_CREATE:[],
    WEB_VISITOR_INVITATION_UPDATE:[routes.visitorInvitation.update],

    WEB_VISITOR_INVITATION_STATUS_DOCUMENTATION_READ:[routes.visitorRequest.documentation],
    WEB_VISITOR_INVITATION_STATUS_DOCUMENTATION_MANAGE:[],
    WEB_VISITOR_INVITATION_STATUS_IDENTIFY_READ:[routes.visitorRequest.documentation],
    WEB_VISITOR_INVITATION_STATUS_IDENTIFY_MANAGE:[],


    WEB_FOODIE_MENU_READ: [routes.foodieMenu.create, routes.foodieMenu.update],
    WEB_FOODIE_MENU_CREATE: [routes.foodieMenu.create],
    WEB_FOODIE_MENU_UPDATE: [],

    WEB_REQUEST_ACCESS_READ : [],
    WEB_REQUEST_ACCESS_MANAGE : [],

    WEB_VISITOR_INCOMING_INVITATION_READ : [routes.guard.main],
    WEB_VISITOR_INCOMING_INVITATION_EXPORT : [],
    WEB_VISITOR_INCOMING_INVITATION_MANAGE : [],

    WEB_EVENT_STATUS_UPDATE: [],
    WEB_EVENT_STATUS_DELETE: [],

    WEB_TRAFFIC_MANAGE_GEOFENCES_READ: [routes.geofences.create, routes.geofences.update],
    WEB_TRAFFIC_MANAGE_GEOFENCES_CREATE: [routes.geofences.create],
    WEB_TRAFFIC_MANAGE_GEOFENCES_UPDATE: [],

    WEB_CONTRACTOR_INCOMING_READ : [routes.guard.main],
    WEB_CONTRACTOR_REQUEST_READ: [routes.contractor.documentRequestDetails],
    WEB_SUPPLIER_REQUEST_READ: [routes.suppliers.documentRequestDetails]
};
